import Main from '../../views/main'
export default [
  /* -------------- 组件调试 ----------- */
  {
    path: '/test-components',
    name: 'TestComponentsParent',
    component: Main,
    meta: {
      hideInBread: true,
      disabled: true,
    },
    children: [
      {
        name: 'TestComponents',
        path: 'test-component-page',
        component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/testComponents'),
        meta: {
          label: '组件调试',
          icon: 'mdi-cellphone-android'
        }
      }
    ]
  },
]
